import { get } from "../../../../server/actions";
import moment from 'moment';

export const cepReimbursementClime=(resp)=>{
    
    let _url=`/cep/reports/${resp.schoolId}/claims/${resp.schoolYear}/${resp.mealType}?startDate=${moment(resp.start,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${ moment(resp.end,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&yearMonth=${resp.yearMonth}&access_token=`;
    return get(_url);
}
export const cepDailyEditCheckReport=(resp)=>{
    let _url=`/cep/reports/${resp.schoolId}/dailyEditCheck/${resp.schoolYear}/${resp.mealType}/${resp.yearMonth}?startDate=${moment(resp.start,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${ moment(resp.end,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&access_token=`;
    return get(_url);
}


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/auditReportComponents/cepServices.js